import baseUrl from './baseUrl';
import isTokenExpired from '../helpers/isTokenExpired';

const URL_GET_CHAMADOS_BUSCA = `${baseUrl}/chamado/busca`;

const getChamadosBusca = async (campo, valor, role, page = 1, limit = 50, email) => {
  try {
    const token = window.localStorage.getItem('token');

    if (token) {
      if (isTokenExpired(token)) {
        window.localStorage.clear();
        window.location.replace('/');

        return;
      }
    }

    const data = await fetch(
      `${URL_GET_CHAMADOS_BUSCA}?campo=${campo}&valor=${valor}&role=${role}&page=${page}&limit=${limit}`, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          email
        }
      }
    );

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }
      
    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getChamadosBusca;
